import styles from "./Steps.module.scss";

const Steps = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export default Steps;
